import { FC, useCallback, useRef, useState } from 'react';

import { SearchInput, Text, useDebounce, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { ReasonsList } from 'components/Admin/ModerationReasonsList/ReasonsList/ReasonsList';

import { useSelector } from 'store/utils';

import styles from 'components/Admin/ModerationReasonsList/ModerationReasonsList.module.less';

const TrlKeys = {
    header: 'admin.moderationReasonsList.header',
    inputPlaceholder: 'admin.moderationReasonsList.input.placeholder',
};

export const ModerationReasonsList: FC = () => {
    const trls = useTrls();

    const moderationReasons = useSelector((state) => state.moderation.moderationReasons);

    const [searchValue, setSearchValue] = useState('');
    const [filteredModerationReasons, setFilteredModerationReasons] = useState(
        moderationReasons.sort((a, b) => a.title.localeCompare(b.title))
    );

    const handleSearchRef = useRef((value: string) => {
        const filteredModerationReasons = moderationReasons.filter(
            ({ title, defaultComment, description }) =>
                title.toLowerCase().includes(value.toLowerCase()) ||
                defaultComment.toLowerCase().includes(value.toLowerCase()) ||
                (description?.toLowerCase().includes(value.toLowerCase()) ?? false)
        );
        setFilteredModerationReasons(filteredModerationReasons);
    });

    const searchDebounced = useDebounce(handleSearchRef.current, 500);

    const handleChange = useCallback(
        (value: string) => {
            setSearchValue(value);
            searchDebounced(value);
        },
        [searchDebounced]
    );

    return (
        <>
            <Text typography="title-3-semibold">{trls(TrlKeys.header)}</Text>
            <VSpacing default={32} />
            <div className={styles.inputWrapper}>
                <SearchInput
                    value={searchValue}
                    placeholder={trls(TrlKeys.inputPlaceholder)}
                    onChange={handleChange}
                    size="small"
                    clearable
                    data-qa="moderation-reasons-search-input"
                />
            </div>
            <VSpacing default={24} />
            <ReasonsList reasons={filteredModerationReasons} />
        </>
    );
};
